// TODO: This should live in utils/conditions and will be moved there once its converted to TS.
export enum ConditionType {
  Action = 'action',
  Attribute = 'attribute',
  CollectionAttribute = 'collection_attribute',
  DeviceAttribute = 'device_attribute',
  Email = 'email',
  Event = 'event',
  EventAttribute = 'event_attribute',
  ForeignEventAttribute = 'foreign_event_attribute',
  Form = 'form',
  Group = 'group',
  Invalid = 'invalid',
  Segments = 'segments',
  SegmentsNegatable = 'segments_negatable',
  NewsletterRecipients = 'newsletter_recipients',
  Message = 'message',
  ObjectAttribute = 'object_attribute',
  PageView = 'pageview',
  Refinement = 'refinement',
  Relationship = 'relationship',
  Screenview = 'screenview',
  RelationshipAttribute = 'relationship_attribute',
}

// Add types with details when needed
export const ConditionDetailsForBoxes: Partial<
  Record<
    ConditionType,
    {
      title: string;
      description: string;
      icon: string;
      isNew?: boolean;
    }
  >
> = {
  [ConditionType.Segments]: {
    title: 'Segment',
    description: "Filter by people whether or not they're in a segment.",
    icon: 'person',
  },
  [ConditionType.SegmentsNegatable]: {
    title: 'Segment',
    description: "Filter by people whether or not they're in a segment.",
    icon: 'person',
  },
  [ConditionType.Attribute]: {
    title: 'Person attribute',
    description: 'Filter by person attributes.',
    icon: 'person',
  },
  [ConditionType.ObjectAttribute]: {
    title: 'Object attribute',
    description: 'Filter by attributes used in object.',
    icon: 'object',
  },
  [ConditionType.RelationshipAttribute]: {
    title: 'Relationship attribute',
    description: 'Filter by attributes used in relationship.',
    icon: 'connections',
  },
};
